// Shared React hook: pull the centralized element list from the backend
// (§3). Auto-seeds on the server if empty and caches in memory for the
// current tab. All UI selectors (skills, enemies, world bosses, items)
// consume this hook — no hardcoded element strings anywhere else.

import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let _cache = null;
const _listeners = new Set();

export function useElements() {
  const [elements, setElements] = useState(_cache || []);
  useEffect(() => {
    let cancelled = false;
    if (_cache) {
      setElements(_cache);
    } else {
      api.gmElements().then(r => {
        if (cancelled) return;
        _cache = r.elements || [];
        setElements(_cache);
        _listeners.forEach(fn => fn(_cache));
      }).catch(() => {});
    }
    const listener = (els) => setElements(els);
    _listeners.add(listener);
    return () => { cancelled = true; _listeners.delete(listener); };
  }, []);
  return elements;
}

export function invalidateElementsCache(nextList) {
  _cache = nextList || null;
  _listeners.forEach(fn => fn(_cache || []));
}

export function getElementByKey(key) {
  if (!_cache) return null;
  return _cache.find(e => e.key === key) || null;
}
